﻿<template>
    <div class="loginContainer">
        <Toast/>
        <div class="bg-surface-0 w-full md:w-4/12 p-12 md:p-20">
            <div class="flex flex-col mb-5 text-center">
                <StaticImage imageClass="datalaneLogo m-auto mb-3" filename="pac-logo.svg"/>
                <div class="text-surface-900 dark:text-surface-0 text-3xl font-medium">Welcome Back</div>
            </div>
            <div>
                <div v-if="firebaseSsoEnabled">
                    <Button :label="ssoButtonLabel" icon="pi pi-user" class="w-full" rounded @click="ssoSignIn"
                            data-cy="loginSSO"></Button>
                    <div v-if="ssoSigninError" class="errorDiv">{{ ssoSigninError }}</div>
                </div>
                <div v-if="basicAuthenticationEnabled">
                    <Divider v-if="firebaseSsoEnabled" align="center" class="my-12">
                        <span class="text-surface-600 dark:text-surface-200 font-normal text-sm">OR</span>
                    </Divider>
                    <div v-if="!basicRequested && firebaseSsoEnabled" class="basicLogin">
                        <a class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer"
                           @click="basicRequested=true" data-cy="loginUserPW">Login with email/password</a>
                    </div>
                    <div v-else>
                        <label for="email"
                               class="block text-surface-900 dark:text-surface-0 font-medium mb-2">Email</label>
                        <InputText id="email" type="text" placeholder="Email address" class="w-full mb-4"
                                   v-model="email"
                                   @input="basicSigninError = null" data-cy="emailBox"/>

                        <label for="password" class="block text-surface-900 dark:text-surface-0 font-medium mb-2"
                               data-cy="passwordLabel">Password</label>
                        <InputText id="password"
                                   type="password"
                                   placeholder="Password"
                                   class="w-full mb-4"
                                   v-model="password"
                                   @input="basicSigninError = null"
                                   @keyup.enter="basicSignIn"
                                   data-cy="passwordBox"/>
                        <div class="errMsg">
                            <Message v-if="basicSigninError" severity="error">{{ basicSigninError }}</Message>
                        </div>
                        <Button label="Sign In with email and password" rounded icon="pi pi-user" data-cy="loginClassic"
                                class="w-full" @click="basicSignIn"></Button>
                        <div class="text-center mt-6">
                            <a class="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer"
                               @click="showForgotPassword=true;resetEmail=email" data-cy="forgotPasswordButton">Forgot
                                password?</a>
                        </div>
                        <Dialog header="Forgot Password?" v-model:visible="showForgotPassword"
                                data-cy="forgotPasswordDialog">
                            <div class="p-6">
                                <label for="email" class="block text-surface-900 dark:text-surface-0 font-medium mb-2"
                                       data-cy="emailLabelForgotPassword">Email</label>
                                <InputText id="email" type="email" placeholder="Email address" class="w-full mb-4"
                                           v-model="resetEmail" data-cy="emailBoxForgotPassword"/>
                                <Button label="Send Reset Email" rounded icon="pi pi-user" class="w-full"
                                        @click="sendResetEmail" :disabled="!validEmail"
                                        data-cy="sendResetEmailButton"></Button>
                            </div>
                        </Dialog>
                    </div>

                </div>
            </div>
        </div>
        <div class="hidden md:block w-8/12 bg-no-repeat bg-cover"
             style="background-image: linear-gradient(to right bottom, #FF6101, #cc612e, #a04532, #712f2e, #421e22, #341b22, #26181f, #191518, #242027, #2b2c38, #2f3949, #2f4858);"></div>
    </div>
</template>
<script setup>
import {provider, auth} from '@/firebaseConfig';
import {signInWithRedirect, signInWithEmailAndPassword, signInWithPopup, sendPasswordResetEmail} from "firebase/auth";
import {ref, computed, nextTick} from 'vue'
import {useRouter} from 'vue-router'
import {ROUTE_NAMES} from "@/src/router";
import {useToast} from 'primevue/usetoast';
import {useStore} from 'vuex';

const store = useStore()

const toast = useToast();
const router = useRouter()

var ssoSigninError = null
var basicSigninError = ref(null)
const ssoButtonLabel = "Single Sign On with " + import.meta.env.VITE_CUSTOMER_NAME + " account"
const firebaseSsoEnabled = computed(() => import.meta.env.VITE_FIREBASE_SSO_ENABLED === 'true')
const basicAuthenticationEnabled = computed(() => import.meta.env.VITE_BASIC_AUTHENTICATION_ENABLED === 'true')

const ssoSignIn = () => {
    auth.onAuthStateChanged(user => {
        if (import.meta.env.VITE_BASE_URL.includes('localhost') || import.meta.env.VITE_BASE_URL.includes('127.0.0.1')) {
            //locally we use popup as we don't have nginx setup
            signInWithPopup(auth, provider)
        } else {
            signInWithRedirect(auth, provider)
        }
    })
}

const basicRequested = ref(false)
const email = ref('')
const password = ref('')

const basicSignIn = () => {
    signInWithEmailAndPassword(auth, email.value, password.value)
      .catch((error) => {
        basicSigninError.value = 'Invalid email or password'
      });
}

const showForgotPassword = ref(false)
const resetEmail = ref('')
const validEmail = computed(() =>
    // test against regex
    resetEmail.value.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
)
const sendResetEmail = () => {

    store.dispatch('userStore/resetPassword', {email: resetEmail.value})
        .then(() => {
            showForgotPassword.value = false
            toast.add({severity: 'success', summary: 'Success', detail: 'Reset email sent', life: 5000});
        })
        .catch((error) => {
            console.log(error)
            //   basicSigninError.value = 'Invalid email'
        });
}
</script>

<style scoped>
.loginContainer {
    height: 100%;
    display: flex;
}

:deep(.datalaneLogo) {
    height: 100px;
    width: 250px;
}

.basicLogin {
    text-align: center;
}

.errMsg {
    width: 100%;
    text-align: center;
    margin-bottom: 1rem;
}
</style>
